export interface ILinkLabel {
    path: string;
    title: string;
}
export interface IPlaceholderItems {
    str: string;
    link: ILinkLabel;
}

const substituteHyperlink = (
    originalLabel: string,
    placeholder: string,
    replacementLink: ILinkLabel
) => {
    let result = originalLabel;
    if (originalLabel?.includes(placeholder)) {
        const labelArray = originalLabel.split(placeholder);
        const path = replacementLink.path;
        const title = replacementLink.title;

        result = `${labelArray[0]}<a href=${path} target="_blank">${title}</a>${labelArray[1]}`;
    }

    return result;
};

export const buildLabel = (placeholderItems: IPlaceholderItems[], parentLabel: string) => {
    return placeholderItems.reduce((acc, item) => {
        return substituteHyperlink(acc, item.str, item.link);
    }, parentLabel);
};

export const isLinkValid = (link: ILinkLabel | undefined) => link && link.path && link.title;
